var baseStyle = {
  lineHeight: "shorter",
  textTransform: "capitalize"
};
var sizes = {
  "3xl": {
    fontFamily: "serif",
    fontSize: ["5xl", "5xl", "5xl", "6xl"],
    verticalAlign: "top",
    fontWeight: "semibold"
  },
  "2xl": {
    fontFamily: "serif",
    fontSize: "5xl",
    verticalAlign: "top",
    fontWeight: "semibold"
  },
  xl: {
    fontFamily: "serif",
    fontSize: "4xl",
    fontWeight: "semibold",
    verticalAlign: "top"
  },
  lg: {
    fontFamily: "serif",
    fontSize: "3xl",
    fontWeight: "semibold",
    verticalAlign: "top"
  },
  md: {
    fontFamily: "serif",
    fontSize: "2xl",
    fontWeight: "semibold"
  },
  sm: {
    fontFamily: "sans",
    fontSize: "xl",
    fontWeight: "semibold"
  },
  xs: {
    fontFamily: "sans",
    fontSize: "lg",
    fontWeight: "semibold",
    textTransform: "uppercase",
    letterSpacing: "wider"
  },
  "2xs": {
    fontFamily: "sans",
    fontSize: "md",
    textTransform: "uppercase",
    fontWeight: "semibold",
    letterSpacing: "wider"
  }
};
var defaultProps = {
  size: "md"
};
export default {
  baseStyle,
  sizes,
  defaultProps
};
//# sourceMappingURL=heading.js.map